import EzController from 'controllers/ez-base-controller';
import events from 'lib/events';
import { triggerCustomEvent } from 'lib/helpers';

export default class EzDropDownController extends EzController {
  connect() {
    this.element.addEventListener(events.util.ez_drop_down.close_drop_down, this.closeDropDown);
    window.addEventListener('keyup', this.allowEscClose);
    document.addEventListener('click', this.blurSubMenus);
  }

  disconnect() {
    this.element.removeEventListener(events.util.ez_drop_down.close_drop_down, this.closeDropDown);
    window.removeEventListener('keyup', this.allowEscClose);
    document.removeEventListener('click', this.blurSubMenus);
  }

  handleSubMenuClick() {
    const subMenuWrapper = this.element;

    this.toggleSubMenu(subMenuWrapper);
  }

  blurSubMenus = (event) => {
    const openSubMenus = document.querySelectorAll('.ez-drop-down.is-open');
    const targetSubMenuWrapper = event.target.closest('.ez-drop-down');

    if (openSubMenus) {
      openSubMenus.forEach((subMenu) => {
        if (targetSubMenuWrapper !== subMenu) {
          triggerCustomEvent(events.util.ez_drop_down.close_drop_down, {}, subMenu);
        }
      });
    }
  }

  closeExploreMenuItems() {
    triggerCustomEvent('CloseSearchExploreSubMenus');
  }

  closeDropDown = () => {
    this.toggleSubMenu(this.element);
  }

  toggleSubMenu(subMenuWrapper) {
    subMenuWrapper.classList.toggle('is-closed');
    subMenuWrapper.classList.toggle('is-open');
  }

  allowEscClose = (event) => {
    // Escape key maps to keycode `27`
    if (event.keyCode === 27) {
      this.blurSubMenus(event);
    }
  }
}
